import * as React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * O que a tela diz enquanto a regra do PBS roda no ERP.
 *
 * Fechar a 1ª contagem de um escopo de 108 endereços levou ~15 s em
 * produção (a SQL-Gravação Final do PBS é longa). Só com o ícone girando a
 * pessoa achou que travou e deu refresh no meio — e o fechamento tinha dado
 * certo. Um contador e o aviso de não fechar a tela resolvem isso.
 */
export function Executando({ ativo, oQue }: { ativo: boolean; oQue: string }): JSX.Element | null {
  const [segundos, definirSegundos] = React.useState(0);
  React.useEffect(() => {
    if (!ativo) {
      definirSegundos(0);
      return;
    }
    const inicio = Date.now();
    const t = window.setInterval(() => definirSegundos(Math.floor((Date.now() - inicio) / 1000)), 500);
    return () => window.clearInterval(t);
  }, [ativo]);
  if (!ativo) return null;
  return (
    <div className="mt-2 flex items-start gap-2 rounded-lg border border-primaria/30 bg-superficie px-3 py-2 text-xs">
      <Loader2 className="mt-0.5 h-4 w-4 shrink-0 animate-spin text-primaria" />
      <p>
        <b>{oQue} no ERP…</b> <span className="tabular">{segundos} s</span>
        <span className="block text-textoFraco">
          Roda a mesma regra do PBS e pode levar até 1 minuto. Não feche nem atualize a tela.
        </span>
      </p>
    </div>
  );
}
